import React, { useMemo } from 'react';
import { motion } from 'framer-motion';

const FloatingOrnaments = ({ speed = 1 }) => {
  const ornaments = useMemo(() => {
    return Array.from({ length: 8 }, (_, i) => ({
      id: i,
      x: Math.random() * 80 + 10,
      y: Math.random() * 80 + 10,
      size: Math.random() * 0.5 + 0.5,
      emoji: ['🎄', '🎁', '🔔', '⭐', '🕯️', '🎀', '🧸', '🍪'][i],
      duration: (Math.random() * 20 + 15) / speed,
      delay: Math.random() * 10
    }));
  }, [speed]);

  return (
    <div className="absolute inset-0 pointer-events-none">
      {ornaments.map((ornament) => (
        <motion.div
          key={ornament.id}
          className="absolute text-4xl"
          style={{
            left: `${ornament.x}%`,
            top: `${ornament.y}%`,
            fontSize: `${ornament.size * 2}rem`
          }}
          animate={{
            y: [0, -30, 0],
            x: [0, Math.sin(ornament.id) * 20, 0],
            rotate: [0, 360],
            scale: [ornament.size, ornament.size * 1.2, ornament.size]
          }}
          transition={{
            duration: ornament.duration,
            repeat: Infinity,
            delay: ornament.delay,
            ease: "easeInOut"
          }}
        >
          {ornament.emoji}
        </motion.div>
      ))}
    </div>
  );
};

export default FloatingOrnaments;